import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const SmartcaptureService = {
    getById: async (id) => axios.get(`${API_URL}/smartcaptures/${id}`).then(({data}) => data).catch((err) => { throw err }),
    options: async () => axios.get(`${API_KEEPER}/smartcapture/options`).then(({data}) => data.data.map(el => ({value: el.id, label: el.text}))).catch((err) => { throw err }),
    getPclMaintenanceGroupsOptions: async () => axios.get(`${API_KEEPER}/pclMaintenanceGroups/options`).then(({data}) => data.data).catch((err) => { throw err }),
    update: async (data) => axios.post(`${API_KEEPER}/smartcapture/update`, data).then(({data}) => data).catch((err) => { throw err }),
    delete: async (data) => axios.post(`${API_KEEPER}/smartcapture/delete`, data).then(({data}) => data).catch((err) => { throw err }),
};

export default SmartcaptureService;
